import React, { useEffect, useState } from "react";
import styles from "./styles.module.css";
// import styles from "../styles.module.css";
import { useMutation, useQueryCache } from 'react-query';
import { postProperty } from "../../../Api/index";
import ExpandedRecordDr6 from "../../ExpandedRecordDr6/index"; // Import your modal component
import useStore from "../../Store/Store"; // Import the store
import expandedRecordIcon from "../images/expandedSVG.svg";

function SearchResults() {
  const { dataResults, isQueryLoading } = useStore();
  const dataRecords = dataResults?.data?.records;
  // State to manage modal visibility and data
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const queryCache = useQueryCache();
  const [errorNotEnoughCredits, setErrorNotEnoughCredits] = useState(false)
  const [snackBarStateError, setSnackBarStateError] = useState(false)

  const [isLoadingRecord, setLoadingRecord] = useState(false); // New state to indicate loading
  // Use useMutation for the POST request
  const [mutate] = useMutation(postProperty, {
    onSuccess: (data) => {
      const newRecord = data?.data?.records[0];
      if (newRecord) {
        const cacheKey = `recordByID-${newRecord.keys[0]}`;
        queryCache.setQueryData(cacheKey, newRecord);
        setSelectedRecord(newRecord);
        setModalOpen(true);
        setLoadingRecord(false); // Set loading false on successful data fetch
      }
    },
    onError: () => {
      setSnackBarStateError(true)
      setTimeout(() => {
        setErrorNotEnoughCredits(true)
        setLoadingRecord(false); // Set loading false on error
      }, 1000)
    }
  });

  const handleRecordClick = (record) => {
    const cacheKey = `recordByID-${record.keys[0]}`;
    const cachedData = queryCache.getQueryData(cacheKey);

    setModalOpen(true);
    setSelectedRecord(cachedData || null);
    setLoadingRecord(!cachedData); // Start loading unless cached data is available

    if (!cachedData && !isQueryLoading) {
      mutate({ query: `keys:"${record?.keys[0]}"` });
    } else if (cachedData) {
      setLoadingRecord(false); // Set loading false immediately if using cached data
    }
  };

  useEffect(() => {
    // Remove all queries that start with 'recordByID'
    if (queryCache) {
      queryCache.getQueries().forEach(query => {
        // Ensure queryKey[0] exists and is a string before calling startsWith
        if (typeof query?.queryKey[0] === 'string' && query.queryKey[0].startsWith('recordByID')) {
          queryCache.removeQueries(query.queryKey);
        }
      });
    }
  }, [dataResults, queryCache]);
  return (
    <section className={styles.searchResultsContainerWithScroll}>
      {/* Repeat this block for each listing */}
      {dataRecords?.map((record, index) => (
        <div
          onClick={() => handleRecordClick(record)}
          key={index}
          className={styles.searchResultsContainer}
          style={{
            opacity: isQueryLoading ? 0.5 : 1, // Change opacity to indicate disabled state
            cursor: isQueryLoading ? "not-allowed" : "pointer", // Change cursor to not-allowed when loading
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", cursor: "pointer", marginBottom: "12px", alignItems: "center", }}>
            <div style={{ display: "flex" }}>
              <span className={styles.testItem} style={{ marginRight: "8px", color: "#8122B4", fontWeight: 500, fontSize: "12px" }}>
                {record.address || "N/A"}
              </span>
              <span style={{ fontSize: "12px", fontWeight: "300" }} className={styles.testItem}>
                {record.city}
                {record.city && record.province ? ", " : ""}
                {record.province}
                {(record.city || record.province) && record.postalCode
                  ? " "
                  : ""}
                {record.postalCode}
              </span>
            </div>
            <div>
              <img style={{ cursor: "pointer", height: "14px", width: "14px" }} src={expandedRecordIcon} alt="ExpandIcon" />
            </div>
          </div>

          {/* Applying right margin to each detail */}

          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "14px 24px", marginBottom: "14px" }}>
            <div className={styles.listingItem}>
              <span style={{ display: "block", color: "#777777", fontSize: "12px", cursor: "pointer" }}>
                Most recent list price
              </span>
              <span style={{ fontSize: "12px", cursor: "pointer" }}>
                {record.mostRecentPriceAmount
                  ? `$${record.mostRecentPriceAmount.toLocaleString("en-US")}`
                  : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", fontSize: "12px", color: "#777777", cursor: "pointer" }}>
                Most recent status
              </span>
              <span style={{ cursor: "pointer" }}>
                {record.mostRecentStatus ? record.mostRecentStatus : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", color: "#777777", fontSize: "12px", cursor: "pointer" }}>
                Most recent rental list price
              </span>
              <span style={{ fontSize: "12px", cursor: "pointer" }}>
                {record.mostRecentRentalListPriceAmount
                  ? `$${record.mostRecentRentalListPriceAmount.toLocaleString("en-US")}`
                  : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", fontSize: "12px", color: "#777777", cursor: "pointer" }}>
                Most recent rental status
              </span>
              <span style={{ cursor: "pointer" }}>
                {record.mostRecentRentalStatus ? record.mostRecentRentalStatus : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", color: "#777777", fontSize: "12px", cursor: "pointer" }}>
                Property type
              </span>
              <span style={{ cursor: "pointer" }}>
                {record.propertyType ? record.propertyType : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", fontSize: "12px", color: "#777777", cursor: "pointer" }}>
                Most recent owner
              </span>
              <span style={{ cursor: "pointer" }}>
                {record?.mostRecentOwnerFirstName || record?.mostRecentOwnerLastName
                  ? `${record.mostRecentOwnerFirstName || ''} ${record.mostRecentOwnerLastName || ''}`.trim()
                  : record?.people && record.people.length > 0 ? (() => {
                      const owner = record.people.find(
                        person => person.title?.toLowerCase() === 'owner'
                      );
                      return owner?.name ||
                        ((owner?.firstName || owner?.lastName)
                          ? `${owner.firstName || ''} ${owner.lastName || ''}`.trim()
                          : 'N/A');
                    })() : 'N/A'}
              </span>
            </div>
            <div className={styles.listingItem}>
              <span style={{ display: "block", fontSize: "12px", color: "#777777", cursor: "pointer" }}>
                Agent
              </span>
              <span style={{ cursor: "pointer" }}>
                {record.mostRecentBrokerAgent
                  ? record.mostRecentBrokerAgent
                  : "N/A"}
              </span>
            </div>
            <div className={styles.listingItem} style={{ display: "flex", alignItems: "center" }}>
              <span style={{ cursor: "pointer" }}>{dataResults?.data?.records?.length} fields available</span>
            </div>
            <div className={styles.listingItem} style={{ display: "flex", alignItems: "center" }}>
              <span style={{ cursor: "pointer" }}>
                {record.imageURLs
                  ? `${record?.imageURLs?.length} images available `
                  : "No Images Found"}
              </span>
            </div>
          </div>
          {/*  */}
        </div>
      ))
      }

      {
        isModalOpen && (
          <ExpandedRecordDr6
            recordData={selectedRecord}
            isLoadingRecord={isLoadingRecord}
            onClose={() => {
              setModalOpen(false);
            }}
            errorNotEnoughCredits={errorNotEnoughCredits}
            setErrorNotEnoughCredits={setErrorNotEnoughCredits}
            snackBarStateError={snackBarStateError}
          />
        )
      }
      {/* End of listing block */}
    </section >
  );
}
export default SearchResults;
